import dayjs from "common/dayjs";
import intersectionBy from "lodash.intersectionby";
import { SHOW_DATE_FORMAT, UTC_DATE_TIME_FORMAT, TIME_24_HOUR_DATE_FORMAT } from "common/constants";
import { Day, RegsDay } from "../types";

export const getDatesBetween = (startDate: string, endDate: string): Date[] => {
  const start = dayjs(startDate).toDate();
  const end = dayjs(endDate).toDate();

  const dates: Date[] = [];

  let currentDate = new Date(start.getFullYear(), start.getMonth(), start.getDate());

  while (currentDate <= end) {
    dates.push(currentDate);
    currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
  }

  return dates;
};

export const getThreeDaysBefore = (startDate: Date) => {
  const dates: Date[] = [];

  for (let i = 1; i < 4; i++) {
    dates.unshift(new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() - i));
  }

  return dates;
}

export const getUtcOffsetDate = (date: string) => {
  const offset = dayjs(date).utcOffset();
  const utcDate = dayjs(date).utcOffset(offset, true).hour(0).minute(0).second(0);

  return utcDate.format(UTC_DATE_TIME_FORMAT);
};

export const validateRegsDays = (regsDays: RegsDay[], eventDates: Day[], withPercentage?: boolean) => {
  const formattedDays = regsDays.map(el => ({ ...el, day: dayjs(el.day).format(SHOW_DATE_FORMAT) }));
  const intersections = intersectionBy(formattedDays, eventDates, "day");
  const regsByDates = intersections.reduce((acc, reg: RegsDay) => ({ ...acc, [reg.day]: reg }), {});

  const regsPerDays: RegsDay[] = [];
  eventDates.forEach(({ day }) => {
    if (regsByDates[day]) regsPerDays.push({ ...regsByDates[day] });
    else regsPerDays.push(withPercentage ? { day, count: 0, percentage: 0 } : { day, count: 0 });
  });

  return regsPerDays;
};

export const getDateTicks = (date: Date) => {
  return date.getTime() * 10000 + 621355968000000000;
};

export const getDifferenceInMinutes = (date1: Date, date2: Date) => {
  const msDifference = +date2 - +date1;
  return Math.floor(msDifference / 1000 / 60);
};

export const getUtcOffsetInHours = (date: string) => dayjs(date).utcOffset() / 60;

export const getHoursMinsFromDate = (date: string) =>
  date ? dayjs(date).add(getUtcOffsetInHours(date), "hour").format(TIME_24_HOUR_DATE_FORMAT) : "";

const DateUtils = {
  getDifferenceInMinutes
};

export default DateUtils;
